/**
 * SelectFilter — dropdown matching the FilterBar select style.
 * Extracted from FilterBar.jsx for reuse across filter configurations.
 */
import { selectStyle } from './filterStyles';

export default function SelectFilter({ value, onChange, options = [], label, style: overrideStyle, testId, ariaLabel }) {
  const mergedStyle = overrideStyle ? { ...selectStyle, ...overrideStyle } : selectStyle;
  return (
    <select
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      style={mergedStyle}
      data-testid={testId}
      aria-label={ariaLabel || label}
    >
      <option value="">{label || 'All'}</option>
      {options.map((opt) => {
        const v = typeof opt === 'string' ? opt : (opt.value ?? opt.id ?? opt.key);
        const lbl = typeof opt === 'string' ? opt : (opt.label ?? opt.name ?? v);
        return (
          <option key={v} value={v}>
            {lbl}
          </option>
        );
      })}
    </select>
  );
}
